import Avvir, { ResponseError } from "avvir";

import makeEventfulAction, { AvvirThunk } from "../make_eventful_action";
import floorTradeDeviationMagnitudesLoaded, { FloorTradeDeviationMagnitudesLoadedEvent } from "../../events/loaded/projects/floor_trade_deviation_magnitudes_loaded";
import projectNotFound, { ProjectNotFoundEvent } from "../../events/notifications/failure_notifications/project_not_found";
import { FloorTradeDeviationMagnitudes } from "../../services/reducers/domain/reduce_floor_trade_deviation_magnitudes";

function loadFloorTradeDeviationMagnitudes(projectId: string, currentScan: boolean): AvvirThunk<Promise<FloorTradeDeviationMagnitudes>, FloorTradeDeviationMagnitudesLoadedEvent | ProjectNotFoundEvent> {
  return (dispatch, getState) => {
    const user = getState().user;

    return Avvir.api.projects.getProjectFloorTradeDeviationMagnitudes({ projectId }, currentScan, user)
      .then((magnitudes) => {
        dispatch(floorTradeDeviationMagnitudesLoaded(projectId, magnitudes, currentScan));
        return magnitudes;
      }).catch((error) => {
        if (error instanceof ResponseError && error.status === 404 && error.message.toLowerCase().includes("project does not exist")) {
          dispatch(projectNotFound());
        } else {
          throw error;
        }
      }) as Promise<FloorTradeDeviationMagnitudes>;
  };
}

export default makeEventfulAction("loadFloorTradeDeviationMagnitudes", loadFloorTradeDeviationMagnitudes);
